import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormHelperText,
  Grid,
  Typography,
} from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useHistory } from "react-router-dom";
import SiteSelect from "../../../shared/selects/SiteSelect";
import UsersBySiteSelect from "../../../shared/selects/UsersBySiteSelect";
import { DistributionService } from "../../../../services/distribution.service";
import { MovileService } from "../../../../services/movile.service";
import { actions } from "../../../../redux/actions/alert";
import { connect } from "react-redux";
import { AuthService } from "../../../../services/auth.service";
import { ProductService } from "../../../../services/product.service";
import { AccesoryService } from "../../../../services/accesory.service";
import { ChipService } from "../../../../services/chip.service";
import { NotificationService } from "../../../../services/notification.service";
import { validateOriginStore } from "../utils.inventory";
import { CashCardService } from "../../../../services/cashCard.service";

const ProductDistributionForm = ({
  addAlert,
  detailAlert,
  onClose,
  itemsIdSelected,
  detailProduct,
  productType,
  bulkCashCard,
}) => {
  const history = useHistory();

  console.log("itemsIdSelected", itemsIdSelected);
  console.log("detailProduct", detailProduct);
  console.log("productType", productType);

  const [distributeOrder, setDistributeOrder] = useState({});
  const [productsArray, setProductsArray] = useState([]);
  const [bulkFinish, setBulkFinish] = useState(false);
  const [hasErrorSite, setHasErrorSite] = useState(false);
  const [hasErrorSeller, setHasErrorSeller] = useState(false);

  useEffect(() => {
    /** Recover user in session for  distribution object */
    (async function () {
      try {
        const {
          user: { id },
        } = await AuthService.getUserInSession();
        setDistributeOrder({
          ...distributeOrder,
          personDeliverId: id,
          statusDistributionId: 1,
          /** Origin site ALMACEN */
          siteId: 1,
        });
      } catch (error) {
        if (error.status === 404) {
          // TODO redirect login create logout service
          setTimeout(() => {
            console.log("user", error.msgs);
            AuthService.logout();
          }, 3000);
        }
        console.log("error", error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs, time: 2000 });
        onClose();
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      if (bulkFinish) {
        try {
          const { data } = await DistributionService.createBulkDistribution(
            productsArray
          );
          const distributionsId = data.map((item) => item.id);
          console.log("distributionsId======", distributionsId);

          const { userId, siteDestinationId } = productsArray[0];
          const notificationObject = {
            distributionsId,
            userId,
            siteId: siteDestinationId,
            open: false,
          };

          const resp = await NotificationService.createNotification(
            notificationObject
          );
          if (resp.status === 201) {
            // socket.emit("notification-channel", resp.data);
          }

          switch (productType) {
            case "movile":
              const { status } = await MovileService.updateAvailableStatus(
                itemsIdSelected
              );
              console.log("movilesAvailableUpdated", status);
              break;

            case "accesory":
              const response = await AccesoryService.updateAvailableStatus(
                itemsIdSelected
              );
              console.log("AccesoriesAvailableUpdated", response.status);
              break;

            case "chip":
              const result = await ChipService.updateAvailableStatus(
                itemsIdSelected
              );
              console.log("chipsAvailableUpdated", result.status);
              break;

            case "cashCard":
              const res = await CashCardService.updateAvailableStatus(
                itemsIdSelected
              );
              console.log("chipsAvailableUpdated", res.status);
              break;
            default:
              break;
          }

          setTimeout(() => {
            let redirect = "";
            switch (productType) {
              case "movile":
                redirect = "/dashboard/inventario/moviles";
                break;
              case "accesory":
                redirect = "/dashboard/inventario/accesorios";
                break;
              case "chip":
                redirect = "/dashboard/inventario/chips";
                break;
              case "cashCard":
                redirect = "/dashboard/inventario/tarjetas-saldo";
                break;
              default:
                redirect = "/dashboard/inventario/moviles";
                break;
            }
            history.push(redirect);
          }, 2000);
          onClose();
          addAlert({ showAlert: true });
          detailAlert({
            severity: "success",
            message: "Transferencia realizada con éxito",
            time: 2000,
          });
        } catch (error) {
          console.log("error", error);
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs, time: 2500 });
        }
      }
    })();
  }, [bulkFinish]);

  const handleSiteSelect = (key, value) => {
    if (value) {
      setDistributeOrder({
        ...distributeOrder,
        siteDestinationId: value,
        userId: undefined,
      });
      setHasErrorSite(false);
    } else setHasErrorSite(true);
  };

  const handleUserSiteSelect = (key, value) => {
    if (key && value) {
      setDistributeOrder({
        ...distributeOrder,
        userId: value,
      });
      setHasErrorSeller(false);
    } else setHasErrorSeller(true);
  };

  const submitProductDistribution = async () => {
    if (distributeOrder.siteDestinationId === undefined) {
      setHasErrorSite(true);
      return;
    }
    if (distributeOrder.userId === undefined) {
      setHasErrorSeller(true);
      return;
    }

    const body = { idItemsArray: itemsIdSelected, type: productType };

    /** Validate distribution origin id 1 = 'Almacen' */
    const { data } = await ProductService.getAllProductsInRangeByType(body);
    console.log("data getAllProductsInRangeByType", data);

    let validateOrigin = null;
    if (data[0].movile) validateOrigin = validateOriginStore(data, "movile");
    else if (data[0].accesory)
      validateOrigin = validateOriginStore(data, "accesory");
    else if (data[0].chip) validateOrigin = validateOriginStore(data, "chip");
    else if (data[0].cash_card)
      validateOrigin = validateOriginStore(data, "cashCard");
    if (!validateOrigin) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "info",
        message:
          "Las distribuciones solo pueden salir desde ALMACÉN, favor de verificar",
        time: 3000,
      });
      onClose();
      return;
    }

    const productsIdArray = [];
    data.forEach((item) =>
      productsIdArray.push({ productId: item.id, ...distributeOrder })
    );
    setProductsArray(productsIdArray);
    // console.log("las copy to BULK", productsIdArray);
    setBulkFinish(true);
  };

  return (
    <>
      <ValidatorForm
        noValidate
        method="POST"
        onSubmit={submitProductDistribution}
        onError={(errors) => {}}
      >
        <Typography
          variant="body1"
          style={{ color: "#0b148e", fontWeight: "600" }}
          gutterBottom
        >
          {itemsIdSelected.length} productos seleccionados
        </Typography>
        <Typography
          variant="body1"
          style={{ color: "#0b148e", fontWeight: "600" }}
          gutterBottom
        >
          {/* Online "" + online */}
        </Typography>
        <Grid
          container
          direction="row"
          justify="space-between"
          spacing={4}
          alignItems="center"
        >
          <Grid item style={{ marginTop: 30 }}>
            <SiteSelect
              removeStore
              site={handleSiteSelect}
              showNone={false}
              title="Sucursal"
            />
            {hasErrorSite && (
              <FormHelperText style={{ color: "#eb4052", fontWeight: 400 }}>
                Es necesario seleccionar una sucursals
              </FormHelperText>
            )}
          </Grid>
          <Grid item style={{ marginTop: 30 }}>
            {
              <UsersBySiteSelect
                user={handleUserSiteSelect}
                siteSelected={distributeOrder.siteDestinationId}
              />
            }
            {hasErrorSeller && (
              <FormHelperText style={{ color: "#eb4052", fontWeight: 400 }}>
                Es necesario seleccionar un vendedor
              </FormHelperText>
            )}
          </Grid>
        </Grid>

        <Grid
          style={{ marginTop: 20 }}
          container
          direction="row"
          justify="space-evenly"
          alignItems="center"
        >
          <Grid item xs={6}>
            <Box mt={5}>
              <Button
                color="primary"
                style={{ marginRight: 50, width: 150 }}
                onClick={() => {
                  setDistributeOrder({
                    ...distributeOrder,
                    siteDestinationId: "",
                    userId: "",
                  });
                  // socket.disconnect();
                  onClose();
                }}
              >
                Cancelar
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box mt={5}>
              <Button
                color="primary"
                style={{ width: 150 }}
                variant="contained"
                type="submit"
              >
                Aceptar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ProductDistributionForm);
